import axios from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    submitting: false,
    lastStatus: null, // 'success' | 'error' | null
    lastError: null,
  },
  getters: {
    submitting: state => state.submitting,
    lastStatus: state => state.lastStatus,
    lastError: state => state.lastError,
  },
  mutations: {
    SET_SUBMITTING(state, val) {
      state.submitting = val
    },
    SET_LAST_STATUS(state, val) {
      state.lastStatus = val
    },
    SET_LAST_ERROR(state, val) {
      state.lastError = val
    },
    RESET_STATE(state) {
      state.submitting = false
      state.lastStatus = null
      state.lastError = null
    },
  },
  actions: {
    async sendMessage(ctx, payload) {
      ctx.commit('SET_SUBMITTING', true)
      ctx.commit('SET_LAST_STATUS', null)
      ctx.commit('SET_LAST_ERROR', null)

      const response = await axios
        .post('/contact', payload) 
        .catch(error => error?.response || error)

      const successStatuses = [200, 201]

      if (response && successStatuses.includes(response.status)) {
        ctx.commit('SET_LAST_STATUS', 'success')
        ctx.commit('SET_SUBMITTING', false)
        return response
      }

      ctx.commit('SET_LAST_STATUS', 'error')
      ctx.commit('SET_LAST_ERROR', response?.data || response)
      ctx.commit('SET_SUBMITTING', false)
      return response
    },
  },
}